import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";

import { API_URL, scroll, getValFromLS, setValToLS } from "../helpers";

import Hdg from "../components/Hdg";
import Alert from "../components/Alert";
import Input from "../components/Input";
import InputReadOnly from "../components/InputReadOnly";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const CharityRegPledge = () => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({
		id: "0",
	});
	const [msg, setMsg] = useState({});
	const [alert, setAlert] = useState({
		type: "working",
		text: "",
	});

	const history = useHistory();

	useEffect(() => {
		scroll();
		init(getValFromLS("crId") || "0");
	}, []);

	const init = async (id) => {
		const url = new URL(`${API_URL}/crPledgeInit`);
		const params = {
			id,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json) {
				setNames({ ...json });
				setAlert({});
				if (json.resp === 0 && getValFromLS("crId")) {
					setValToLS("crId", "");
				}
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	const handleUpdate = (name, value) => {
		if (name === "sets" && !isNaN(value)) {
			const forms = value * 100;
			setNames((names) => ({ ...names, forms }));
		}
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/crPledge`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setValToLS("crId", json.id);
				history.push("/registration");
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div id="full-column">
			<Hdg section="Registration" />
			<Fragment>
				{alert.type ? (
					<Alert data={alert} />
				) : (
					<Fragment>
						<h3>
							<i className="fa fa-file-text-o" /> &nbsp;Donor Commitment Form
							Information
						</h3>
						<p>
							Register by <span className="bold">September 8, 2026</span>, to
							have your information pre-printed on your donor commmitment forms.
							Should you have any questions, please contact{" "}
							<a href="mailto:stephanie@valerotexasopen.com">
								Stephanie@ValeroTexasOpen.com
							</a>{" "}
							or at 210.345.3839.
						</p>

						<form
							method="post"
							action="/"
							onSubmit={(e) => handleSubmit(e)}
							className="well"
						>
							<div className="form-group" style={{ marginBottom: "0" }}>
								<Input
									name="sets"
									label="Number of donor commmitment form sets needed"
									reqd={true}
									value={names.sets || ""}
									update={handleUpdate}
									errors={errors}
									note="Come in sets of 100, ex. 10 sets = 1,000 donor commmitment forms. If you do NOT want custom donation forms, please type in “0” to indicate that you will be doing strictly a digital/online campaign."
								/>
								<InputReadOnly
									label="Total forms"
									reqd={false}
									value={names.forms || ""}
								/>
							</div>

							<p style={{ marginTop: "10px" }}>
								There is a custom box to recognize the benefiting charity on the
								donor commmitment form. Up to five lines are available for your
								information. Please write out exactly how you would like it to
								look.
							</p>

							<div className="form-group" style={{ marginTop: "10px" }}>
								<InputReadOnly
									label="Line 1 &nbsp;&nbsp;<span class='normal'>(DBA Name, must match as entered in Step 1)</span>"
									reqd={true}
									value={names.line1 || ""}
								/>
								<div className="empty" />
							</div>

							<div className="form-group">
								<Input
									name="line2"
									label="Line 2 &nbsp;&nbsp;<span class='normal'>(Ex. Attn:)</span>"
									reqd={false}
									value={names.line2 || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<div className="empty" />
							</div>

							<div className="form-group">
								<Input
									name="line3"
									label="Line 3 &nbsp;&nbsp;<span class='normal'>(Ex. Address)</span>"
									reqd={false}
									value={names.line3 || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<div className="empty" />
							</div>

							<div className="form-group">
								<Input
									name="line4"
									label="Line 4 &nbsp;&nbsp;<span class='normal'>(Ex. City, State Zip)</span>"
									reqd={false}
									value={names.line4 || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<div className="empty" />
							</div>

							<div className="form-group">
								<Input
									name="line5"
									label="Line 5 &nbsp;&nbsp;<span class='normal'>(Ex. Phone / Website)</span>"
									reqd={false}
									value={names.line5 || ""}
									update={handleUpdate}
									errors={errors}
								/>
								<div className="empty" />
							</div>
							<div className="msg-submit">
								{msg.type && <Msg data={msg} />}

								<div
									className={
										msg.type === "working" || msg.type === "success"
											? "hidden"
											: "submit-container"
									}
								>
									<Submit
										path="/registration"
										left="Back"
										submit="Submit Donor Commitment Form Information"
									/>
								</div>
							</div>
						</form>
					</Fragment>
				)}
			</Fragment>
		</div>
	);
};

export default CharityRegPledge;
